import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getRemoteConfig } from 'firebase/remote-config'
import { getFirebaseConfig, validateFirebaseConfig } from '~/config/firebase'

export default defineNuxtPlugin(() => {
  // Get Firebase configuration
  const firebaseConfig = getFirebaseConfig()
  
  // Validate Firebase configuration
  try {
    validateFirebaseConfig(firebaseConfig)
  } catch (error) {
    console.error('Firebase configuration error:', error)
    return
  }

  // Initialize Firebase
  let app
  let auth
  let remoteConfig = null

  try {
    app = initializeApp(firebaseConfig)
    auth = getAuth(app)
    
    // Initialize Remote Config with error handling
    try {
      remoteConfig = getRemoteConfig(app)

  // Configure Remote Config
  remoteConfig.defaultConfig = {
    maintenance_mode: false,
    maintenance_message: 'We are currently performing scheduled maintenance. We will be back online shortly.'
  }

  // Set cache expiration based on environment
  const isDev = process.env.NODE_ENV === 'development'
  remoteConfig.settings = {
    minimumFetchIntervalMillis: isDev ? 30000 : 120000, // 30s dev, 2min prod
    fetchTimeoutMillis: 60000, // 1 minute
      }
    } catch (remoteConfigError) {
      console.warn('Failed to initialize Firebase Remote Config:', remoteConfigError)
      // Continue without Remote Config - app can still function
  }

  // Connect to Firebase Auth emulator in development if configured
  if (process.env.NODE_ENV === 'development' && process.env.NUXT_PUBLIC_FIREBASE_AUTH_EMULATOR_HOST) {
    try {
      connectAuthEmulator(auth, `http://${process.env.NUXT_PUBLIC_FIREBASE_AUTH_EMULATOR_HOST}`)
      console.log('Connected to Firebase Auth emulator')
    } catch (error) {
      console.warn('Failed to connect to Firebase Auth emulator:', error)
    }
    }
  } catch (error) {
    console.error('Failed to initialize Firebase:', error)
    return
  }

  return {
    provide: {
      firebaseApp: app,
      firebaseAuth: auth,
      firebaseRemoteConfig: remoteConfig,
    }
  }
})
